import React from "react";
import { motion } from "framer-motion";
import { 
  Box, 
  Typography, 
  Button, 
  Container
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "@/translations/TranslationContext";
import "./MobileHero.css";

// Styled components
const HeroButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#ABBD23',
  color: '#fff',
  borderRadius: 25,
  padding: '15px 20px',
  textTransform: 'none',
  fontFamily: '"Montserrat", sans-serif',
  fontWeight: 600,
  width: '100%',
  maxWidth: '250px',
  margin: '0 auto',
  '&:hover': {
    backgroundColor: '#8A9919',
    transform: 'translateY(-2px)',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
  },
}));

const HeroChip = styled(Box)(({ theme }) => ({
  display: 'inline-block',
  backgroundColor: '#ABBD23',
  color: 'white',
  padding: '8px 16px',
  borderRadius: 20,
  fontSize: 14,
  fontWeight: 600,
  marginBottom: 20,
  fontFamily: '"Montserrat", sans-serif',
}));

function MobileHero() {
  const { t } = useTranslation();

  return (
    <Box className="mobile-hero-section">
      <Container maxWidth="sm">
        <Box className="mobile-hero-content">
          {/* No animation for the chip */}
          <HeroChip>
            {t.hero.tagline}
          </HeroChip>
          
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <Typography 
              variant="h1" 
              sx={{ 
                fontSize: { xs: '28px', sm: '32px' }, 
                lineHeight: 1.3, 
                marginBottom: '20px', 
                color: 'white',
                fontFamily: '"Montserrat", sans-serif',
                fontWeight: 700
              }}
            >
              <Box component="span" sx={{ fontWeight: 'bold' }}>
                {t.hero.title.highlight1}
              </Box>
              {t.hero.title.part2}
              <Box component="span" sx={{ fontWeight: 'bold' }}>
                {t.hero.title.highlight2}
              </Box>
            </Typography>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <Typography 
              variant="body2" 
              sx={{ 
                fontSize: '14px', 
                textTransform: 'uppercase', 
                marginBottom: '25px', 
                color: 'white',
                fontFamily: '"Montserrat", sans-serif',
                fontWeight: 500
              }}
            >
              {t.hero.consultation}
            </Typography>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            style={{ width: '100%', textAlign: 'center' }}
          >
            <HeroButton
              variant="contained"
              disableElevation
              href="/contact"
            >
              {t.hero.contactUs}
            </HeroButton>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
}

export default MobileHero;
